/**
 * @typedef {Object} Banner
 * @property {string} imageUrl
 * @property {string} title
 * @property {string} link
 * @property {string} tipo  — 'catalogo' | 'banner'
 */

export const isCatalog = (banner) => banner !== null && banner.tipo === 'catalogo';

export const isRegularBanner = (banner) => banner !== null && banner.tipo !== 'catalogo';